const bankOpportunityOptionTranslations = {
  en: {
    bank: "Bank",
    servicer: "Servicer",
    insolvency: "Insolvency",
    judicial_sale: "Judicial sale",
    auction: "Auction",
    creditor: "Creditor",
    broker: "Broker",
    direct_owner: "Direct owner",
    other: "Other",
    bank_owned: "Bank-owned",
    distressed: "Distressed",
    non_performing_loan: "Non-performing loan",
    restructuring: "Restructuring",
    special_situation: "Special situation",
    draft: "Draft",
    under_review: "Under review",
    verified: "Verified",
    published: "Published",
    closed: "Closed",
    unverified: "Unverified",
    partially_verified: "Partially verified",
    unprotected: "Unprotected",
    under_negotiation: "Under negotiation",
    protected: "Protected",
    invoiced: "Invoiced",
    paid: "Paid",
    none: "None",
    seller: "Seller mandate",
    buyer: "Buyer mandate",
    co_broker: "Co-broker",
    introducer: "Introducer",
  },
  pt: {
    bank: "Banco",
    servicer: "Servicer",
    insolvency: "Insolvência",
    judicial_sale: "Venda judicial",
    auction: "Leilão",
    creditor: "Credor",
    broker: "Mediador",
    direct_owner: "Proprietário direto",
    other: "Outro",
    bank_owned: "Propriedade bancária",
    distressed: "Ativo em situação especial",
    non_performing_loan: "Crédito não produtivo",
    restructuring: "Reestruturação",
    special_situation: "Situação especial",
    draft: "Rascunho",
    under_review: "Em análise",
    verified: "Verificado",
    published: "Publicado",
    closed: "Encerrado",
    unverified: "Não verificado",
    partially_verified: "Parcialmente verificado",
    unprotected: "Sem proteção",
    under_negotiation: "Em negociação",
    protected: "Protegido",
    invoiced: "Faturado",
    paid: "Pago",
    none: "Nenhum",
    seller: "Mandato do vendedor",
    buyer: "Mandato do comprador",
    co_broker: "Partilha de mediação",
    introducer: "Apresentador",
  },
  zh: {
    bank: "银行",
    servicer: "资产服务机构",
    insolvency: "破产",
    judicial_sale: "司法出售",
    auction: "拍卖",
    creditor: "债权人",
    broker: "经纪人",
    direct_owner: "业主直售",
    other: "其他",
    bank_owned: "银行持有",
    distressed: "困境资产",
    non_performing_loan: "不良贷款",
    restructuring: "重组",
    special_situation: "特殊机会",
    draft: "草稿",
    under_review: "审核中",
    verified: "已核实",
    published: "已发布",
    closed: "已结束",
    unverified: "未核实",
    partially_verified: "部分核实",
    unprotected: "未受保护",
    under_negotiation: "谈判中",
    protected: "已受保护",
    invoiced: "已开票",
    paid: "已支付",
    none: "无",
    seller: "卖方委托",
    buyer: "买方委托",
    co_broker: "联合经纪",
    introducer: "介绍方",
  },
  fr: {
    bank: "Banque",
    servicer: "Gestionnaire d’actifs",
    insolvency: "Insolvabilité",
    judicial_sale: "Vente judiciaire",
    auction: "Enchère",
    creditor: "Créancier",
    broker: "Intermédiaire",
    direct_owner: "Propriétaire direct",
    other: "Autre",
    bank_owned: "Actif bancaire",
    distressed: "Actif en difficulté",
    non_performing_loan: "Prêt non performant",
    restructuring: "Restructuration",
    special_situation: "Situation spéciale",
    draft: "Brouillon",
    under_review: "En cours d’examen",
    verified: "Vérifié",
    published: "Publié",
    closed: "Clôturé",
    unverified: "Non vérifié",
    partially_verified: "Partiellement vérifié",
    unprotected: "Non protégé",
    under_negotiation: "En négociation",
    protected: "Protégé",
    invoiced: "Facturé",
    paid: "Payé",
    none: "Aucun",
    seller: "Mandat vendeur",
    buyer: "Mandat acheteur",
    co_broker: "Co-intermédiaire",
    introducer: "Apporteur d’affaires",
  },
  es: {
    bank: "Banco",
    servicer: "Gestor de activos",
    insolvency: "Insolvencia",
    judicial_sale: "Venta judicial",
    auction: "Subasta",
    creditor: "Acreedor",
    broker: "Intermediario",
    direct_owner: "Propietario directo",
    other: "Otro",
    bank_owned: "Activo bancario",
    distressed: "Activo en dificultad",
    non_performing_loan: "Préstamo dudoso",
    restructuring: "Reestructuración",
    special_situation: "Situación especial",
    draft: "Borrador",
    under_review: "En revisión",
    verified: "Verificado",
    published: "Publicado",
    closed: "Cerrado",
    unverified: "No verificado",
    partially_verified: "Parcialmente verificado",
    unprotected: "Sin protección",
    under_negotiation: "En negociación",
    protected: "Protegido",
    invoiced: "Facturado",
    paid: "Pagado",
    none: "Ninguno",
    seller: "Mandato de venta",
    buyer: "Mandato de compra",
    co_broker: "Co-intermediario",
    introducer: "Presentador",
  },
  de: {
    bank: "Bank",
    servicer: "Servicer",
    insolvency: "Insolvenz",
    judicial_sale: "Gerichtlicher Verkauf",
    auction: "Auktion",
    creditor: "Gläubiger",
    broker: "Vermittler",
    direct_owner: "Direkteigentümer",
    other: "Sonstige",
    bank_owned: "Bankeigentum",
    distressed: "Notleidender Vermögenswert",
    non_performing_loan: "Notleidender Kredit",
    restructuring: "Restrukturierung",
    special_situation: "Sondersituation",
    draft: "Entwurf",
    under_review: "In Prüfung",
    verified: "Geprüft",
    published: "Veröffentlicht",
    closed: "Abgeschlossen",
    unverified: "Ungeprüft",
    partially_verified: "Teilweise geprüft",
    unprotected: "Ungeschützt",
    under_negotiation: "In Verhandlung",
    protected: "Geschützt",
    invoiced: "In Rechnung gestellt",
    paid: "Bezahlt",
    none: "Keines",
    seller: "Verkäufermandat",
    buyer: "Käufermandat",
    co_broker: "Kooperationsmakler",
    introducer: "Geschäftsvermittler",
  },
  it: {
    bank: "Banca",
    servicer: "Gestore di attivi",
    insolvency: "Insolvenza",
    judicial_sale: "Vendita giudiziaria",
    auction: "Asta",
    creditor: "Creditore",
    broker: "Intermediario",
    direct_owner: "Proprietario diretto",
    other: "Altro",
    bank_owned: "Proprietà bancaria",
    distressed: "Attivo in difficoltà",
    non_performing_loan: "Credito deteriorato",
    restructuring: "Ristrutturazione",
    special_situation: "Situazione speciale",
    draft: "Bozza",
    under_review: "In revisione",
    verified: "Verificato",
    published: "Pubblicato",
    closed: "Chiuso",
    unverified: "Non verificato",
    partially_verified: "Parzialmente verificato",
    unprotected: "Non protetto",
    under_negotiation: "In negoziazione",
    protected: "Protetto",
    invoiced: "Fatturato",
    paid: "Pagato",
    none: "Nessuno",
    seller: "Mandato del venditore",
    buyer: "Mandato dell’acquirente",
    co_broker: "Co-intermediario",
    introducer: "Presentatore",
  },
  ru: {
    bank: "Банк",
    servicer: "Сервисная компания",
    insolvency: "Несостоятельность",
    judicial_sale: "Судебная продажа",
    auction: "Аукцион",
    creditor: "Кредитор",
    broker: "Посредник",
    direct_owner: "Прямой собственник",
    other: "Другое",
    bank_owned: "Банковский актив",
    distressed: "Проблемный актив",
    non_performing_loan: "Проблемный кредит",
    restructuring: "Реструктуризация",
    special_situation: "Особая ситуация",
    draft: "Черновик",
    under_review: "На проверке",
    verified: "Проверено",
    published: "Опубликовано",
    closed: "Закрыто",
    unverified: "Не проверено",
    partially_verified: "Частично проверено",
    unprotected: "Без защиты",
    under_negotiation: "На переговорах",
    protected: "Защищено",
    invoiced: "Счёт выставлен",
    paid: "Оплачено",
    none: "Нет",
    seller: "Мандат продавца",
    buyer: "Мандат покупателя",
    co_broker: "Совместный брокер",
    introducer: "Представляющая сторона",
  },
};

export default bankOpportunityOptionTranslations;
